import {inject} from '@angular/core';
import {CanActivateChildFn, CanActivateFn} from '@angular/router';
import {DirectBookingEntryParametersService} from '../services/direct-booking-entry-parameters.service';

export const directBookingEntryParametersGuard: CanActivateFn = (_route, state) => {
  inject(DirectBookingEntryParametersService).persistFromUrl(state.url);

  return true;
};

export const directBookingEntryParametersChildGuard: CanActivateChildFn = (_route, state) => {
  inject(DirectBookingEntryParametersService).persistFromUrl(state.url);

  return true;
};
